"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BreadcrumbPropTypes = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constant = require("@airasia/phoenix-components/components/Theme/constant");

var _constant2 = require("./constant");

var BreadcrumbPropTypes = {
  PropTypes: {
    theme: _propTypes.default.string,
    crumbs: _propTypes.default.array,
    accessible: _propTypes.default.bool,
    customProperties: _propTypes.default.object,
    disabledColor: _propTypes.default.oneOf(_constant.ARR_COLORS),
    activeColor: _propTypes.default.oneOf(_constant.ARR_COLORS),
    isClickable: _propTypes.default.bool,
    hoverUnderlined: _propTypes.default.bool,
    hoverColor: _propTypes.default.bool,
    activeStep: _propTypes.default.number,
    hasBorderBottom: _propTypes.default.bool,
    fontSize: _propTypes.default.oneOf(_constant.ARR_FONT_SIZE),
    target: _propTypes.default.oneOf(Object.keys(_constant2.TARGET))
  },
  DefaultProps: {
    theme: _constant.DEFAULT_THEME,
    accessible: true,
    isClickable: false,
    disabledColor: _constant2.TEXT_TYPE.disabled.color,
    activeColor: _constant2.TEXT_TYPE.active.color,
    hoverUnderlined: false,
    hoverColor: '',
    hasBorderBottom: false,
    fontSize: _constant2.TEXT_TYPE.active.size,
    target: _constant2.TARGET.TAB
  }
};
exports.BreadcrumbPropTypes = BreadcrumbPropTypes;